export default "__VITE_ASSET__DTR1f18P__"